import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { HomeBgImg } from "@/assets"
import { Button } from "@/ui/Button"
import s from "./404.module.scss"

export const PageNotFound: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div
      className={s.PageNotFound_root}
      style={{ backgroundImage: `url(${HomeBgImg})` }}
    >
      <div className={s.PageNotFound_overlay} />

      <div className={s.PageNotFound_content}>
        <h1 className={s.PageNotFound_title}>{t("pageNotFound.title")}</h1>
        <p className={s.PageNotFound_subtitle}>{t("pageNotFound.subtitle")}</p>
        <Button className={s.PageNotFound_button} onClick={() => navigate("/")}>
          {t("pageNotFound.back")}
        </Button>
      </div>
    </div>
  )
}
